/**
 * Created by shiyonggao on 2019/1/22.
 */
module.exports = {
    'zh-CN': require('./lang/lang_zh'),
    'en-US': require('./lang/lang_en'),
    'ar-AE': require('./lang/lang_ar'),
    'de-DE': require('./lang/lang_de'),
    'el-GR': require('./lang/lang_el'),
    'es-ES': require('./lang/lang_es'),
    'fr-FR': require('./lang/lang_fr'),
    'it-IT': require('./lang/lang_it'),
    'ja-JP': require('./lang/lang_ja'),
    'nl-NL': require('./lang/lang_nl'),
    'pl-PL': require('./lang/lang_pl'),
    'pt-PT': require('./lang/lang_pt'),
    'ru-RU': require('./lang/lang_ru'),
    'sv-SE': require('./lang/lang_sv'),
    'tr-TR': require('./lang/lang_tr'),
    'zh-TW': require('./lang/lang_tw')
};


// WEBPACK FOOTER //
// ./website/language/lang_config.js